import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { UserRequestsComponent } from './user-requests.component';

const routes: Routes = [
  { path: '', component: UserRequestsComponent, data: { title: 'User Registration Requests' } },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class UserRequestsRoutingModule {}

@NgModule({
  imports: [
    UserRequestsRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
  ],
  declarations: [UserRequestsComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class UserRequestsModule {}
